import script from "./LoadTasksMixin.vue?vue&type=script&lang=js"
export * from "./LoadTasksMixin.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__